import Carousel from "react-simply-carousel";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image, { ImageI } from "components/Elements/Image/Image";
import { useEffect, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import apiRequest from "utils/ApiRequest/apiRequest";
import styles from "./styles.module.scss";

interface PartnerLogoI {
  fileLocation: string;
  fileName: string;
  fileType: ImageI["ext"];
}

const SLIDES_SIZES = {
  mobile: {
    itemsToShow: 1,
    minWidth: 320,
  },
  tablet: {
    itemsToShow: 2,
    minWidth: 770,
  },
  smallDesktop: {
    itemsToShow: 3,
    minWidth: 1000,
  },
  desktop: {
    itemsToShow: 4,
    minWidth: 1250,
  },
};

export const HomePartnersSection = () => {
  const [partnersLogos, setPartnersLogos] = useState<PartnerLogoI[]>();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const { getTextByKey, getLanguage, getDirection } = useContent();

  useEffect(() => {
    getPartnersLogos();
  }, []);

  const getPartnersLogos = async () => {
    const res = await apiRequest("Logos", "ReactGetLogos", {
      culture: getLanguage(),
    } as any);

    if (res.status === "success") setPartnersLogos(res.data);
  };

  const isSliderControlButtonsHidden = () =>
    Object.values(SLIDES_SIZES).some(
      (size) =>
        window.matchMedia(`(min-width: ${size.minWidth}px)`) &&
        partnersLogos?.length <= size.itemsToShow
    );

  if (!Array.isArray(partnersLogos) || !partnersLogos?.length) return null;

  return (
    <section className={styles.partners}>
      <h2 className={styles.title}>{getTextByKey("home-partners-title")}</h2>
      <Carousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={SLIDES_SIZES.desktop.itemsToShow}
        itemsToScroll={1}
        dirRTL={getDirection() === "rtl"}
        infinite
        forwardBtnProps={{
          hidden: isSliderControlButtonsHidden(),
          className: styles.arrowRight,
          children: (
            <Icon
              iconClass="arrow-carousel"
              name={getDirection() === "rtl" ? "arrow-left" : "arrow-right"}
            />
          ),
        }}
        backwardBtnProps={{
          hidden: isSliderControlButtonsHidden(),
          className: styles.arrowLeft,
          children: (
            <Icon
              iconClass="arrow-carousel"
              name={getDirection() === "rtl" ? "arrow-right" : "arrow-left"}
            />
          ),
        }}
        responsiveProps={Object.values(SLIDES_SIZES)}
        speed={400}
        easing="linear"
      >
        {partnersLogos.map((logo) => (
          <div className={styles.logoWrap} key={logo.fileName}>
            <Image
              className={styles.logo}
              src={logo.fileLocation}
              ext={logo.fileType}
              alt={`${logo.fileName} logo`}
              title={logo.fileName}
            />
          </div>
        ))}
      </Carousel>

      <p className={styles.more}>{getTextByKey("home-thousands-more")}</p>
    </section>
  );
};
